import styled from 'styled-components';
import { bottom, compose, left, right, top, zIndex } from 'styled-system';
import { Box } from '../Box/Box';
/**
 * @public
 */
export const Absolute = /*#__PURE__*/styled(Box).withConfig({
  displayName: "Absolute",
  componentId: "sc-1sjf63y-0"
})(["position:absolute;", ""], props => compose(top, bottom, left, right, zIndex)(props));
Absolute.displayName = 'Absolute';